const BASE_URL = '/common/view_logs'
export const createViewLogsApi = ({ POST }) => ({
  createItem: (data) => POST(BASE_URL, data),
})

export type ViewLogsApi = ReturnType<typeof createViewLogsApi>
